import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadZahlungsBedingungListStatus: 'idle',
    loadZahlungsBedingungListError: undefined as any,
    loadZahlungsBedingungListLastArgs: undefined as any,
    loadZahlungsBedingungStatus: 'idle',
    loadZahlungsBedingungError: undefined as any,
    saveZahlungsBedingungStatus: 'idle',
    saveZahlungsBedingungError: undefined as any,
    deleteZahlungsBedingungStatus: 'idle',
    deleteZahlungsBedingungError: undefined as any,

    zahlungsBedingungList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadZahlungsBedingungList = createAsyncThunk('zahlungsBedingungSlice/loadZahlungsBedingungList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().zahlungsBedingungSlice.loadZahlungsBedingungListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuriszahlbed/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadZahlungsBedingungListStatus } = getState().zahlungsBedingungSlice
        return loadZahlungsBedingungListStatus !== 'pending'
    }
})

export const loadZahlungsBedingung = createAsyncThunk('zahlungsBedingungSlice/loadZahlungsBedingung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuriszahlbed/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadZahlungsBedingungStatus } = getState().zahlungsBedingungSlice
        return loadZahlungsBedingungStatus !== 'pending'
    }
})

export const saveZahlungsBedingung = createAsyncThunk('zahlungsBedingungSlice/saveZahlungsBedingung', async ({ zahlungsBedingung }: any, { rejectWithValue }: any) => {
    let promises = []
    if (zahlungsBedingung?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuriszahlbed/${ zahlungsBedingung?.HDR_ID }/`,
            prepareData(zahlungsBedingung),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuriszahlbed/`,
            prepareData(zahlungsBedingung),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveZahlungsBedingungStatus } = getState().zahlungsBedingungSlice
        return saveZahlungsBedingungStatus !== 'pending'
    }
})

export const deleteZahlungsBedingung = createAsyncThunk('zahlungsBedingungSlice/deleteZahlungsBedingung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuriszahlbed/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteZahlungsBedingungStatus } = getState().zahlungsBedingungSlice
        return deleteZahlungsBedingungStatus !== 'pending'
    }
})

const ZahlungsBedingungSlice = createSlice({
    name: 'zahlungsBedingungSlice',
    initialState,
    reducers: {
        resetloadZahlungsBedingungListError: (state) => {
            state.loadZahlungsBedingungListError = undefined
        },
        resetloadZahlungsBedingung: (state) => {
            state.formItem = undefined
            state.loadZahlungsBedingungError = undefined
        },
        resetloadZahlungsBedingungError: (state) => {
            state.loadZahlungsBedingungError = undefined
        },
        resetsaveZahlungsBedingung: (state) => {
            state.formItem = undefined
            state.saveZahlungsBedingungError = undefined
        },
        resetsaveZahlungsBedingungError: (state) => {
            state.saveZahlungsBedingungError = undefined
        },
        resetdeleteZahlungsBedingungError: (state) => {
            state.deleteZahlungsBedingungError = undefined
        },
        removeFromZahlungsBedingungListById: (state, action) => {
            state.zahlungsBedingungList = state.zahlungsBedingungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromZahlungsBedingungListByIds: (state, action) => {
            state.zahlungsBedingungList = state.zahlungsBedingungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.zahlungsBedingungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadZahlungsBedingungListStatus = 'preloaded'
            state.loadZahlungsBedingungListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.zahlungsBedingungList = []
            state.loadZahlungsBedingungListStatus = 'idle'
            state.loadZahlungsBedingungListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadZahlungsBedingungList.pending, (state) => {
            state.loadZahlungsBedingungListStatus = 'pending'
            state.loadZahlungsBedingungListError = undefined
        })
        builder.addCase(loadZahlungsBedingungList.fulfilled, (state, action) => {
            state.loadZahlungsBedingungListStatus = 'idle'

            if (!action.payload) { return }

            state.loadZahlungsBedingungListLastArgs = action.payload.args

            {
                state.zahlungsBedingungList = action.payload.data

            }
        })
        builder.addCase(loadZahlungsBedingungList.rejected, (state, action) => {
            state.loadZahlungsBedingungListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadZahlungsBedingungListError = action.error.message
            } else {
                state.loadZahlungsBedingungListError = action.payload
            }
        })

        builder.addCase(loadZahlungsBedingung.pending, (state) => {
            state.loadZahlungsBedingungStatus = 'pending'
            state.loadZahlungsBedingungError = undefined
        })
        builder.addCase(loadZahlungsBedingung.fulfilled, (state, action) => {
            state.loadZahlungsBedingungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.zahlungsBedingungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.zahlungsBedingungList.push(newItem) }
                else { state.zahlungsBedingungList[i] = { ...state.zahlungsBedingungList[i], ...newItem } }
            }
        })
        builder.addCase(loadZahlungsBedingung.rejected, (state, action) => {
            state.loadZahlungsBedingungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadZahlungsBedingungError = action.error.message
            } else {
                state.loadZahlungsBedingungError = action.payload
            }
        })

        builder.addCase(saveZahlungsBedingung.pending, (state) => {
            state.saveZahlungsBedingungStatus = 'pending'
            state.saveZahlungsBedingungError = undefined
        })
        builder.addCase(saveZahlungsBedingung.fulfilled, (state, action) => {
            state.saveZahlungsBedingungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.zahlungsBedingungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.zahlungsBedingungList.push(newItem) }
                else { state.zahlungsBedingungList[i] = { ...state.zahlungsBedingungList[i], ...newItem } }
            }
        })
        builder.addCase(saveZahlungsBedingung.rejected, (state, action) => {
            state.saveZahlungsBedingungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveZahlungsBedingungError = action.error.message
            } else {
                state.saveZahlungsBedingungError = action.payload
            }
        })

        builder.addCase(deleteZahlungsBedingung.pending, (state) => {
            state.deleteZahlungsBedingungStatus = 'pending'
            state.deleteZahlungsBedingungError = undefined
        })
        builder.addCase(deleteZahlungsBedingung.fulfilled, (state, action) => {
            state.deleteZahlungsBedingungStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.zahlungsBedingungList = state.zahlungsBedingungList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.zahlungsBedingungList = state.zahlungsBedingungList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteZahlungsBedingung.rejected, (state, action) => {
            state.deleteZahlungsBedingungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteZahlungsBedingungError = action.error.message
            } else {
                state.deleteZahlungsBedingungError = action.payload
            }
        })

    }
})

export const {
    resetloadZahlungsBedingungListError,
    resetloadZahlungsBedingung,
    resetloadZahlungsBedingungError,
    resetsaveZahlungsBedingung,
    resetsaveZahlungsBedingungError,
    resetdeleteZahlungsBedingungError,
    removeFromZahlungsBedingungListById,
    removeFromZahlungsBedingungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ZahlungsBedingungSlice.actions
export default ZahlungsBedingungSlice.reducer
